"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_top_tabs_1 = require("@react-navigation/material-top-tabs");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../assets/icons/BackHeader"));
const header_1 = require("../../components/header");
const ModalMenu_1 = __importDefault(require("../../components/modal/ModalMenu"));
const ModalSuccess_1 = __importDefault(require("../../components/modal/ModalSuccess"));
const CustomText_1 = __importDefault(require("../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const scale_1 = require("../../utils/scale");
const DisconnectScreen_1 = require("../DisconnectScreen");
const HashtagListScreen_1 = require("./HashtagListScreen");
const styles_1 = __importDefault(require("./styles"));
const CustomTabBar = ({ state, descriptors, navigation, tabBarOptions, }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.tabContainer, tabBarOptions.style] },
        react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: scale_1.isPC, contentContainerStyle: { flexDirection: "row" } }, state.routes.map((route, index) => {
            const { options } = descriptors[route.key];
            const isFocused = state.index === index;
            const label = options.tabBarLabel !== undefined
                ? options.tabBarLabel
                : route.name;
            return (react_1.default.createElement(react_native_1.TouchableOpacity, { key: index, onPress: () => navigation.navigate(route.name), style: styles_1.default.tab, activeOpacity: 1 },
                react_1.default.createElement(CustomText_1.default, { weight: isFocused ? '600' : '300', style: [styles_1.default.tabLabel, { color: isFocused ? '#007AFF' : '#888888' }] }, label),
                react_1.default.createElement(react_native_1.View, { style: {
                        width: '100%',
                        height: (0, scale_1.scale)(4),
                        backgroundColor: '#DDDDDD',
                    } }, isFocused && (react_1.default.createElement(react_native_1.View, { style: {
                        width: '100%',
                        height: (0, scale_1.scale)(4),
                        backgroundColor: '#007AFF',
                        borderRadius: 99,
                    } })))));
        }))));
};
const Tab = (0, material_top_tabs_1.createMaterialTopTabNavigator)();
const HashtagScreen = (props) => {
    const navigation = (0, native_1.useNavigation)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    const [visibleToast, setVisibleToast] = (0, react_1.useState)(false);
    const [contentToast, setContentToast] = (0, react_1.useState)("");
    const { typeHashTag = 0 } = props.route?.params;
    (0, react_1.useEffect)(() => {
        setContentToast(props.route?.params);
    }, []);
    (0, react_1.useEffect)(() => {
        const focusTab = navigation.addListener('focus', (_e) => {
            if (typeHashTag == 2) {
                navigation.navigate(Routes_1.default.history);
            }
            else if (typeHashTag == 1) {
                navigation.navigate(Routes_1.default.article);
            }
        });
        return focusTab;
    }, [navigation]);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: { backgroundColor: '#F7F7F7', flex: 1 } },
        react_1.default.createElement(header_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'ハッシュタグ', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#21242D' }), onLeftPress: navigation.goBack }),
        react_1.default.createElement(Tab.Navigator, { tabBar: (props) => (react_1.default.createElement(CustomTabBar, { ...props, tabBarOptions: {
                    scrollEnabled: true,
                    tabStyle: { width: 'auto' },
                    indicatorStyle: { backgroundColor: 'blue' },
                    style: {},
                } })), screenOptions: {
                swipeEnabled: false,
                lazy: true,
            } },
            react_1.default.createElement(Tab.Screen, { name: "all", component: HashtagListScreen_1.ListHashtagScreen, initialParams: { type: 0 }, options: {
                    tabBarLabel: 'すべて',
                } }),
            react_1.default.createElement(Tab.Screen, { name: "article", component: HashtagListScreen_1.ListHashtagScreen, initialParams: { type: 1 }, options: {
                    tabBarLabel: '記事',
                } }),
            react_1.default.createElement(Tab.Screen, { name: "history", component: HashtagListScreen_1.ListHashtagScreen, initialParams: { type: 2 }, options: {
                    tabBarLabel: '自分史',
                } }),
            react_1.default.createElement(Tab.Screen, { name: "timeline", component: HashtagListScreen_1.ListHashtagScreen, initialParams: { type: 3 }, options: {
                    tabBarLabel: 'タイムライン',
                } }),
            react_1.default.createElement(Tab.Screen, { name: "profile", component: HashtagListScreen_1.ListHashtagScreen, initialParams: { type: 4 }, options: {
                    tabBarLabel: 'プロフィール・フォロー',
                } })),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) }),
        react_1.default.createElement(ModalSuccess_1.default, { visible: visibleToast, onClose: () => setVisibleToast(false), content: contentToast })));
};
exports.default = HashtagScreen;
